<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                Neue Bestätigungsmahnung
            </modal-header>
            <modal-content>
                <form-input aria-invalid="date" label="Mahnungsdatum" v-model="form.date" :error="form.errors.date" disabled="true" />
                <form-text id="comment" label="Kommentar" v-model="form.comment" :error="form.errors.comment" />
                <form-html id="text" label="Nachricht an Produzenten" v-model="form.text" :error="form.errors.text" height="300px" />
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Absenden</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import {useForm} from '@inertiajs/vue3';
import FormText from '@partfactory/Shared/Form/FormText';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormHtml from '@partfactory/Shared/Form/FormHtml';

export default {
    name: 'ProducerOrderConfirmationReminderModal',
    components: {FormHtml, FormInput, FormText, ModalContent, ModalHeader, FormButton, ModalActions, Modal},
    props: {
        askForQuote: Object,
    },
    emit: ['closeDialog'],
    data() {

        if (this.askForQuote?.producer_order?.producer_user?.language === 2) {
            this.$language.current = 'en';
        }

        const translated = this.$gettext('<h1>Guten Tag %{name},</h1>' +
            '<p>wir haben noch keine Auftragsbestätigung für Ihren Auftrag <a href=":producerorder">%{pfnumber}</a> erhalten. Bitte bestätigen Sie den Auftrag, sonst müssen wir Ihren Auftrag leider anderweitig vergeben</p>');

        const text = this.$gettextInterpolate(translated, {
            name: this.askForQuote?.producer_order?.producer_user?.name,
            pfnumber: this.askForQuote.pfnumber,
        });

        this.$language.current = 'de';

        const form = useForm({
            date: this.$moment().format('DD.MM.YYYY'),
            comment: null,
            text: text,
        });
        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.confirmation.reminder', {'askForQuote': this.askForQuote.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        }
    }
};
</script>
